import { omitBy } from 'lodash';

/**
 * remove all undefined values from the obj
 * @param obj
 */
export function cleanObject(obj: any) {
  return omitBy(obj, (v) => v === undefined);
}

/**
 * Remove all undefined and empty-string values from the obj.
 * Useful for stripping blank query params before API requests.
 */
export function stripEmptyValues(obj: Record<string, any>) {
  return omitBy(obj, (v) => v === undefined || v === '');
}

export function addUniqueIDsToArrayItems(list: Array<any>) {
  const cloned = structuredClone(list);
  return cloned.map((data: any) => ({ __id: crypto.randomUUID(), ...data }));
}

export function reorder(list: Array<any>, currentIndex = -1, newIndex = -1) {
  const copiedArrayList = Array.from(list);

  /**
   * Remove the item from its current position in the copied array.
   * - currentIndex: the index of the item to be removed.
   */
  const [removed] = copiedArrayList.splice(currentIndex, 1);

  /**
   * Insert the removed item at the new specified index in the copied array.
   * - newIndex: the target index where the removed item will be inserted.
   * - `0`: specifies that no elements should be deleted at the insertion point.
   * - `removed`: the item previously removed from the array, now reinserted at newIndex.
   */
  copiedArrayList.splice(newIndex, 0, removed);

  return copiedArrayList;
}

export function getKeyByValue<T extends object, K extends keyof T>(
  obj: T,
  value: T[K],
): K | undefined {
  return Object.keys(obj).find((key) => obj[key as keyof T] === value) as K | undefined;
}

export function isRagNode(nodeType: string) {
  return [
    'query_prompt',
    'context_enricher',
    'llm_processor',
    'query_response',
    'query_rewriter',
    'data_retriever_holder',
  ].includes(nodeType);
}

export function isApiServerNode(nodeType: string) {
  return [
    'api_server',
    'api_request',
    'api_success_modifier',
    'splitter_output',
    'api_error',
    'api_target',
    'api_error_modifier',
  ].includes(nodeType);
}
